import { Employee } from '@app/models/employee/employee.model';
import { Candidate } from '@app/models/offer-letters/candidate.model';
import { MultiAvatarColumn } from '@app/modules/table/classes/multi-avatar-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class CosignerColumn extends MultiAvatarColumn<Candidate> {
    title = 'offer-letter.cosigners';
    type: CellDisplay = CellDisplay.multiAvatar;

    getEmployees(candidate: Candidate): Employee[] {
        return candidate.latestOfferLetter.cosigners.map((signatureRequest) => signatureRequest.employee);
    }
}
